;(function ( $ ) {

    /**
     *  equalHeight
     *  set elements to equal height
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'equalHeight';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.checkEqualHeight();
            var _this = this;
            $(window).smartresize(function() {
                _this.checkEqualHeight();
            });
        },
        checkEqualHeight: function () {
            console.log($(this.element));
            var elements = $(this.element).find('.equal-height-wrapper');
            var maxHeight = 0;
            for (var i = 0; i < elements.length; i++) {
                //console.log($(elements[i]));
                if ($(elements[i]).height() > maxHeight) {
                    maxHeight = $(elements[i]).height();
                }
            }
            for (i = 0; i < elements.length; i++) {
                $(elements[i]).css({
                    'position': 'relative'
                });

                if(window.innerWidth >= 1024){
                    $(elements[i]).height(maxHeight);
                    $(elements[i]).find('.button:last-child').css({
                        'position': 'absolute',
                        'bottom': 0,
                        'left': 0
                    });
                }
                else {
                    $(elements[i]).css('height', 'auto');
                    $(elements[i]).find('.button:last-child').css({
                        'position': 'relative'
                    });
                }
            }
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
